import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import BodyTab from './BodyTab';
import ParamTab from './ParamTab';
import AuthTab from './AuthTab';
import HeadersTab from './HeadersTab';
import { AuthState, QueryParam, BodyState, HeaderParam } from './types';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
interface BasicTabsProps {
  url: string;
  method: string;
  params: QueryParam[];
  setParams: React.Dispatch<React.SetStateAction<QueryParam[]>>;
  auth: AuthState;
  setAuth: React.Dispatch<React.SetStateAction<AuthState>>;
  body: BodyState;
  setBody: React.Dispatch<React.SetStateAction<BodyState>>;
  header: HeaderParam[];
  setHeaders: React.Dispatch<React.SetStateAction<HeaderParam[]>>;
  viewMode: boolean;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({
  url,
  method,
  params,
  setParams,
  auth,
  setAuth,
  body,
  setBody,
  header,
  setHeaders,
  viewMode,
}: BasicTabsProps) {
  const [tabValue, setTabValue] = useState(0);

  const tabItems = [
    {
      name: 'Params',
      body: <ParamTab url={url} params={params} setParams={setParams} viewMode={viewMode} />,
    },
    {
      name: 'Body',
      body: <BodyTab body={body} setBody={setBody} method={method} viewMode={viewMode} />,
    },
    { name: 'Auth', body: <AuthTab auth={auth} setAuth={setAuth} viewMode={viewMode} /> },
    {
      name: 'Headers',
      body: <HeadersTab headers={header} setHeaders={setHeaders} viewMode={viewMode} />,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={(event, newValue) => {
            setTabValue(newValue);
          }}
          aria-label="basic tabs example"
        >
          {tabItems.map((item, index) => {
            return <Tab key={index} label={item.name} {...a11yProps(index)} />;
          })}
        </Tabs>
      </Box>

      {tabItems.map((item, index) => {
        return (
          <CustomTabPanel key={index} value={tabValue} index={index}>
            {item.body}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
}
